
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

$parcel$export(module.exports, "ForgeContentTools", () => $0c33e41081c1500e$export$7cf22b806dbb23cb);
/* ForgeContentTools.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $7QUD1 = parcelRequire("7QUD1");
var $7Ndnw = parcelRequire("7Ndnw");
var $8a9Dm = parcelRequire("8a9Dm");
var $hIaUw = parcelRequire("hIaUw");
var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");

var $ep3mz = parcelRequire("ep3mz");

var $6UqI3 = parcelRequire("6UqI3");
var $6uUjl = parcelRequire("6uUjl");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $5ZqQS = parcelRequire("5ZqQS");

var $3jwuS = parcelRequire("3jwuS");

var $041p6 = parcelRequire("041p6");

var $9MrOn = parcelRequire("9MrOn");
const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, dialogs: dialogs, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $gwFzn.useState)(null);
    const [isLoading, setLoading] = (0, $gwFzn.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $gwFzn.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $gwFzn.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $gwFzn.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $gwFzn.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]); // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $gwFzn.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9MrOn.ContentToolsButton), {
                isLoading: true // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                ,
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, undefined, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB,
        dialogs: dialogs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $dIouf.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $041p6.ForgeContentToolsItem), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader({ extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose, dialogs: dialogs }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const onInitialRender = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.succeed({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME
        });
        onLoadComplete();
        const appId = (0, $8a9Dm.getAppId)(extension);
        const analyticEvent = createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'invoked',
                actionSubject: 'forgeExtension',
                actionSubjectId: appId,
                containerType: 'space',
                containerId: spaceId,
                objectType: (0, $hIaUw.getContentType)(routeName),
                objectId: contentId,
                source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                attributes: {
                    activationId: activationId,
                    appId: appId,
                    moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                    spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                    spaceId: spaceId
                }
            }
        });
        analyticEvent.fire();
    }, [
        onLoadComplete,
        experienceTracker,
        activationId,
        createAnalyticsEvent,
        contentId,
        spaceAlias,
        spaceId,
        extension,
        routeName
    ]);
    if (!spaceKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7QUD1.ContentActionForgeApp // this key is required to enable user switch in between different forge apps during loading of an extension
    ), {
        key: extension.id,
        app: extension,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            // @ts-ignore FIXME `type` is declared by `extensionData` to be required for `content`
            content: {
                id: contentId,
                subtype: isLivePage ? 'live' : null
            },
            space: {
                key: spaceKey || spaceAlias,
                id: spaceId
            }
        },
        onInitialRender: onInitialRender,
        onTearDown: onClose,
        dialogs: dialogs
    }));
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};

});
parcelRegister("7QUD1", function(module, exports) {

$parcel$export(module.exports, "ByLineForgeApp", () => $02976f123c8f8e25$export$d2159b9f3f077903);
$parcel$export(module.exports, "ContentActionForgeApp", () => $02976f123c8f8e25$export$f900958ce7c4410f);
$parcel$export(module.exports, "ContextMenuForgeApp", () => $02976f123c8f8e25$export$79ed117743c6c2cf);
$parcel$export(module.exports, "GlobalPageForgeApp", () => $02976f123c8f8e25$export$83db8797814193a8);
$parcel$export(module.exports, "GlobalSettingsForgeApp", () => $02976f123c8f8e25$export$74528162c4c3828b);
$parcel$export(module.exports, "HomepageFeedForgeApp", () => $02976f123c8f8e25$export$c8291e2d6d6adbf2);
$parcel$export(module.exports, "SpaceSettingsForgeApp", () => $02976f123c8f8e25$export$e8858129e933f7e8);
$parcel$export(module.exports, "CustomContentForgeApp", () => $02976f123c8f8e25$export$578d0cbdb0ffa72e);
$parcel$export(module.exports, "BackgroundScriptForgeApp", () => $02976f123c8f8e25$export$40d4b5cfa6c18ea7);
$parcel$export(module.exports, "PageBannerForgeApp", () => $02976f123c8f8e25$export$c76787f94e0b1609);

var $jmjWc = parcelRequire("jmjWc");

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("43z1f"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("7vFOh"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("8Wpxv"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("5cubf"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9eERy"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("cL9st"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("bWjKz"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("cRbwd"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("bAGUV"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("cnJpO"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("5Zv3R"))).PageBannerForgeApp
});

});
parcelRegister("43z1f", function(module, exports) {

let $2f429b521cb5368d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2f429b521cb5368d$var$load("f0WOR"),
    $2f429b521cb5368d$var$load("k7roz"),
    $2f429b521cb5368d$var$load("is6uI"),
    $2f429b521cb5368d$var$load("lnKog"),
    $2f429b521cb5368d$var$load("bKdog"),
    $2f429b521cb5368d$var$load("8eNS3"),
    $2f429b521cb5368d$var$load("50LrB"),
    $2f429b521cb5368d$var$load("77pyi"),
    $2f429b521cb5368d$var$load("4gZEH"),
    $2f429b521cb5368d$var$load("gkmZg"),
    $2f429b521cb5368d$var$load("kQvbt"),
    $2f429b521cb5368d$var$load("jQFGH"),
    $2f429b521cb5368d$var$load("fQ1rW"),
    $2f429b521cb5368d$var$load("4tUsp"),
    $2f429b521cb5368d$var$load("f96v0"),
    $2f429b521cb5368d$var$load("ev7SX"),
    $2f429b521cb5368d$var$load("gQSWJ"),
    $2f429b521cb5368d$var$load("5tHTv"),
    $2f429b521cb5368d$var$load("26IOy"),
    $2f429b521cb5368d$var$load("2nuqm"),
    $2f429b521cb5368d$var$load("giPb3"),
    $2f429b521cb5368d$var$load("ecOVI"),
    $2f429b521cb5368d$var$load("7X74w"),
    $2f429b521cb5368d$var$load("4we3T"),
    $2f429b521cb5368d$var$load("gavZG"),
    $2f429b521cb5368d$var$load("1hjmQ"),
    $2f429b521cb5368d$var$load("h4Nf7"),
    $2f429b521cb5368d$var$load("4fCJZ"),
    $2f429b521cb5368d$var$load("9FBaW"),
    $2f429b521cb5368d$var$load("2S1L6"),
    $2f429b521cb5368d$var$load("6StWh"),
    $2f429b521cb5368d$var$load("g9CVe"),
    $2f429b521cb5368d$var$load("U7y88"),
    $2f429b521cb5368d$var$load("fEx3B"),
    $2f429b521cb5368d$var$load("dJQEi"),
    $2f429b521cb5368d$var$load("j4gWN"),
    $2f429b521cb5368d$var$load("87F9B"),
    $2f429b521cb5368d$var$load("4aLlP"),
    $2f429b521cb5368d$var$load("aZinD"),
    $2f429b521cb5368d$var$load("6qah4"),
    $2f429b521cb5368d$var$load("c6MKV"),
    $2f429b521cb5368d$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("7vFOh", function(module, exports) {

let $577bdc3ae67ff2d3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $577bdc3ae67ff2d3$var$load("f0WOR"),
    $577bdc3ae67ff2d3$var$load("k7roz"),
    $577bdc3ae67ff2d3$var$load("is6uI"),
    $577bdc3ae67ff2d3$var$load("lnKog"),
    $577bdc3ae67ff2d3$var$load("bKdog"),
    $577bdc3ae67ff2d3$var$load("8eNS3"),
    $577bdc3ae67ff2d3$var$load("50LrB"),
    $577bdc3ae67ff2d3$var$load("77pyi"),
    $577bdc3ae67ff2d3$var$load("4gZEH"),
    $577bdc3ae67ff2d3$var$load("gkmZg"),
    $577bdc3ae67ff2d3$var$load("kQvbt"),
    $577bdc3ae67ff2d3$var$load("jQFGH"),
    $577bdc3ae67ff2d3$var$load("fQ1rW"),
    $577bdc3ae67ff2d3$var$load("4tUsp"),
    $577bdc3ae67ff2d3$var$load("f96v0"),
    $577bdc3ae67ff2d3$var$load("ev7SX"),
    $577bdc3ae67ff2d3$var$load("gQSWJ"),
    $577bdc3ae67ff2d3$var$load("5tHTv"),
    $577bdc3ae67ff2d3$var$load("26IOy"),
    $577bdc3ae67ff2d3$var$load("2nuqm"),
    $577bdc3ae67ff2d3$var$load("giPb3"),
    $577bdc3ae67ff2d3$var$load("ecOVI"),
    $577bdc3ae67ff2d3$var$load("7X74w"),
    $577bdc3ae67ff2d3$var$load("4we3T"),
    $577bdc3ae67ff2d3$var$load("gavZG"),
    $577bdc3ae67ff2d3$var$load("1hjmQ"),
    $577bdc3ae67ff2d3$var$load("h4Nf7"),
    $577bdc3ae67ff2d3$var$load("4fCJZ"),
    $577bdc3ae67ff2d3$var$load("9FBaW"),
    $577bdc3ae67ff2d3$var$load("2S1L6"),
    $577bdc3ae67ff2d3$var$load("6StWh"),
    $577bdc3ae67ff2d3$var$load("g9CVe"),
    $577bdc3ae67ff2d3$var$load("U7y88"),
    $577bdc3ae67ff2d3$var$load("fEx3B"),
    $577bdc3ae67ff2d3$var$load("dJQEi"),
    $577bdc3ae67ff2d3$var$load("j4gWN"),
    $577bdc3ae67ff2d3$var$load("87F9B"),
    $577bdc3ae67ff2d3$var$load("4aLlP"),
    $577bdc3ae67ff2d3$var$load("aZinD"),
    $577bdc3ae67ff2d3$var$load("6qah4"),
    $577bdc3ae67ff2d3$var$load("c6MKV"),
    $577bdc3ae67ff2d3$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("8Wpxv", function(module, exports) {

let $68278d21ab7a35f0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $68278d21ab7a35f0$var$load("f0WOR"),
    $68278d21ab7a35f0$var$load("k7roz"),
    $68278d21ab7a35f0$var$load("is6uI"),
    $68278d21ab7a35f0$var$load("lnKog"),
    $68278d21ab7a35f0$var$load("bKdog"),
    $68278d21ab7a35f0$var$load("8eNS3"),
    $68278d21ab7a35f0$var$load("50LrB"),
    $68278d21ab7a35f0$var$load("77pyi"),
    $68278d21ab7a35f0$var$load("4gZEH"),
    $68278d21ab7a35f0$var$load("gkmZg"),
    $68278d21ab7a35f0$var$load("kQvbt"),
    $68278d21ab7a35f0$var$load("jQFGH"),
    $68278d21ab7a35f0$var$load("fQ1rW"),
    $68278d21ab7a35f0$var$load("4tUsp"),
    $68278d21ab7a35f0$var$load("f96v0"),
    $68278d21ab7a35f0$var$load("ev7SX"),
    $68278d21ab7a35f0$var$load("gQSWJ"),
    $68278d21ab7a35f0$var$load("5tHTv"),
    $68278d21ab7a35f0$var$load("26IOy"),
    $68278d21ab7a35f0$var$load("2nuqm"),
    $68278d21ab7a35f0$var$load("giPb3"),
    $68278d21ab7a35f0$var$load("ecOVI"),
    $68278d21ab7a35f0$var$load("7X74w"),
    $68278d21ab7a35f0$var$load("4we3T"),
    $68278d21ab7a35f0$var$load("gavZG"),
    $68278d21ab7a35f0$var$load("1hjmQ"),
    $68278d21ab7a35f0$var$load("h4Nf7"),
    $68278d21ab7a35f0$var$load("4fCJZ"),
    $68278d21ab7a35f0$var$load("9FBaW"),
    $68278d21ab7a35f0$var$load("2S1L6"),
    $68278d21ab7a35f0$var$load("6StWh"),
    $68278d21ab7a35f0$var$load("g9CVe"),
    $68278d21ab7a35f0$var$load("U7y88"),
    $68278d21ab7a35f0$var$load("fEx3B"),
    $68278d21ab7a35f0$var$load("dJQEi"),
    $68278d21ab7a35f0$var$load("j4gWN"),
    $68278d21ab7a35f0$var$load("87F9B"),
    $68278d21ab7a35f0$var$load("4aLlP"),
    $68278d21ab7a35f0$var$load("aZinD"),
    $68278d21ab7a35f0$var$load("6qah4"),
    $68278d21ab7a35f0$var$load("c6MKV"),
    $68278d21ab7a35f0$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("5cubf", function(module, exports) {

let $3c957bf1d1b590e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3c957bf1d1b590e8$var$load("k7roz"),
    $3c957bf1d1b590e8$var$load("is6uI"),
    $3c957bf1d1b590e8$var$load("4gZEH"),
    $3c957bf1d1b590e8$var$load("gkmZg"),
    $3c957bf1d1b590e8$var$load("kQvbt"),
    $3c957bf1d1b590e8$var$load("jQFGH"),
    $3c957bf1d1b590e8$var$load("fQ1rW"),
    $3c957bf1d1b590e8$var$load("4tUsp"),
    $3c957bf1d1b590e8$var$load("26IOy"),
    $3c957bf1d1b590e8$var$load("2nuqm"),
    $3c957bf1d1b590e8$var$load("giPb3"),
    $3c957bf1d1b590e8$var$load("ecOVI"),
    $3c957bf1d1b590e8$var$load("7X74w"),
    $3c957bf1d1b590e8$var$load("4we3T"),
    $3c957bf1d1b590e8$var$load("gavZG"),
    $3c957bf1d1b590e8$var$load("1hjmQ"),
    $3c957bf1d1b590e8$var$load("h4Nf7"),
    $3c957bf1d1b590e8$var$load("4fCJZ"),
    $3c957bf1d1b590e8$var$load("9FBaW"),
    $3c957bf1d1b590e8$var$load("2S1L6"),
    $3c957bf1d1b590e8$var$load("6StWh"),
    $3c957bf1d1b590e8$var$load("g9CVe"),
    $3c957bf1d1b590e8$var$load("U7y88"),
    $3c957bf1d1b590e8$var$load("fEx3B"),
    $3c957bf1d1b590e8$var$load("dJQEi"),
    $3c957bf1d1b590e8$var$load("6qah4"),
    $3c957bf1d1b590e8$var$load("j4gWN"),
    $3c957bf1d1b590e8$var$load("87F9B"),
    $3c957bf1d1b590e8$var$load("aZinD"),
    $3c957bf1d1b590e8$var$load("c6MKV"),
    $3c957bf1d1b590e8$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("9eERy", function(module, exports) {

let $6b951e59b1364fc6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6b951e59b1364fc6$var$load("k7roz"),
    $6b951e59b1364fc6$var$load("is6uI"),
    $6b951e59b1364fc6$var$load("4gZEH"),
    $6b951e59b1364fc6$var$load("gkmZg"),
    $6b951e59b1364fc6$var$load("kQvbt"),
    $6b951e59b1364fc6$var$load("jQFGH"),
    $6b951e59b1364fc6$var$load("fQ1rW"),
    $6b951e59b1364fc6$var$load("4tUsp"),
    $6b951e59b1364fc6$var$load("26IOy"),
    $6b951e59b1364fc6$var$load("2nuqm"),
    $6b951e59b1364fc6$var$load("giPb3"),
    $6b951e59b1364fc6$var$load("ecOVI"),
    $6b951e59b1364fc6$var$load("7X74w"),
    $6b951e59b1364fc6$var$load("4we3T"),
    $6b951e59b1364fc6$var$load("gavZG"),
    $6b951e59b1364fc6$var$load("1hjmQ"),
    $6b951e59b1364fc6$var$load("h4Nf7"),
    $6b951e59b1364fc6$var$load("4fCJZ"),
    $6b951e59b1364fc6$var$load("9FBaW"),
    $6b951e59b1364fc6$var$load("2S1L6"),
    $6b951e59b1364fc6$var$load("6StWh"),
    $6b951e59b1364fc6$var$load("g9CVe"),
    $6b951e59b1364fc6$var$load("U7y88"),
    $6b951e59b1364fc6$var$load("fEx3B"),
    $6b951e59b1364fc6$var$load("dJQEi"),
    $6b951e59b1364fc6$var$load("6qah4"),
    $6b951e59b1364fc6$var$load("j4gWN"),
    $6b951e59b1364fc6$var$load("87F9B"),
    $6b951e59b1364fc6$var$load("aZinD"),
    $6b951e59b1364fc6$var$load("c6MKV"),
    $6b951e59b1364fc6$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("cL9st", function(module, exports) {

let $94a1360c86abbcb6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $94a1360c86abbcb6$var$load("k7roz"),
    $94a1360c86abbcb6$var$load("is6uI"),
    $94a1360c86abbcb6$var$load("lnKog"),
    $94a1360c86abbcb6$var$load("4gZEH"),
    $94a1360c86abbcb6$var$load("gkmZg"),
    $94a1360c86abbcb6$var$load("kQvbt"),
    $94a1360c86abbcb6$var$load("jQFGH"),
    $94a1360c86abbcb6$var$load("fQ1rW"),
    $94a1360c86abbcb6$var$load("4tUsp"),
    $94a1360c86abbcb6$var$load("26IOy"),
    $94a1360c86abbcb6$var$load("2nuqm"),
    $94a1360c86abbcb6$var$load("giPb3"),
    $94a1360c86abbcb6$var$load("ecOVI"),
    $94a1360c86abbcb6$var$load("7X74w"),
    $94a1360c86abbcb6$var$load("4we3T"),
    $94a1360c86abbcb6$var$load("gavZG"),
    $94a1360c86abbcb6$var$load("1hjmQ"),
    $94a1360c86abbcb6$var$load("h4Nf7"),
    $94a1360c86abbcb6$var$load("4fCJZ"),
    $94a1360c86abbcb6$var$load("9FBaW"),
    $94a1360c86abbcb6$var$load("2S1L6"),
    $94a1360c86abbcb6$var$load("6StWh"),
    $94a1360c86abbcb6$var$load("g9CVe"),
    $94a1360c86abbcb6$var$load("U7y88"),
    $94a1360c86abbcb6$var$load("fEx3B"),
    $94a1360c86abbcb6$var$load("dJQEi"),
    $94a1360c86abbcb6$var$load("6qah4"),
    $94a1360c86abbcb6$var$load("j4gWN"),
    $94a1360c86abbcb6$var$load("87F9B"),
    $94a1360c86abbcb6$var$load("aZinD"),
    $94a1360c86abbcb6$var$load("c6MKV"),
    $94a1360c86abbcb6$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("bWjKz", function(module, exports) {

let $8b146e73fb524438$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8b146e73fb524438$var$load("k7roz"),
    $8b146e73fb524438$var$load("is6uI"),
    $8b146e73fb524438$var$load("lnKog"),
    $8b146e73fb524438$var$load("4gZEH"),
    $8b146e73fb524438$var$load("gkmZg"),
    $8b146e73fb524438$var$load("kQvbt"),
    $8b146e73fb524438$var$load("jQFGH"),
    $8b146e73fb524438$var$load("fQ1rW"),
    $8b146e73fb524438$var$load("4tUsp"),
    $8b146e73fb524438$var$load("f96v0"),
    $8b146e73fb524438$var$load("ev7SX"),
    $8b146e73fb524438$var$load("5tHTv"),
    $8b146e73fb524438$var$load("26IOy"),
    $8b146e73fb524438$var$load("2nuqm"),
    $8b146e73fb524438$var$load("giPb3"),
    $8b146e73fb524438$var$load("ecOVI"),
    $8b146e73fb524438$var$load("7X74w"),
    $8b146e73fb524438$var$load("4we3T"),
    $8b146e73fb524438$var$load("gavZG"),
    $8b146e73fb524438$var$load("1hjmQ"),
    $8b146e73fb524438$var$load("h4Nf7"),
    $8b146e73fb524438$var$load("4fCJZ"),
    $8b146e73fb524438$var$load("dTsOE"),
    $8b146e73fb524438$var$load("9FBaW"),
    $8b146e73fb524438$var$load("2S1L6"),
    $8b146e73fb524438$var$load("6StWh"),
    $8b146e73fb524438$var$load("g9CVe"),
    $8b146e73fb524438$var$load("U7y88"),
    $8b146e73fb524438$var$load("fEx3B"),
    $8b146e73fb524438$var$load("dJQEi"),
    $8b146e73fb524438$var$load("6qah4"),
    $8b146e73fb524438$var$load("j4gWN"),
    $8b146e73fb524438$var$load("87F9B"),
    $8b146e73fb524438$var$load("4aLlP"),
    $8b146e73fb524438$var$load("aZinD"),
    $8b146e73fb524438$var$load("c6MKV"),
    $8b146e73fb524438$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("cRbwd", function(module, exports) {

let $95c35ea47ac23405$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $95c35ea47ac23405$var$load("k7roz"),
    $95c35ea47ac23405$var$load("is6uI"),
    $95c35ea47ac23405$var$load("lnKog"),
    $95c35ea47ac23405$var$load("4gZEH"),
    $95c35ea47ac23405$var$load("gkmZg"),
    $95c35ea47ac23405$var$load("kQvbt"),
    $95c35ea47ac23405$var$load("jQFGH"),
    $95c35ea47ac23405$var$load("fQ1rW"),
    $95c35ea47ac23405$var$load("4tUsp"),
    $95c35ea47ac23405$var$load("f96v0"),
    $95c35ea47ac23405$var$load("ev7SX"),
    $95c35ea47ac23405$var$load("5tHTv"),
    $95c35ea47ac23405$var$load("26IOy"),
    $95c35ea47ac23405$var$load("2nuqm"),
    $95c35ea47ac23405$var$load("giPb3"),
    $95c35ea47ac23405$var$load("ecOVI"),
    $95c35ea47ac23405$var$load("7X74w"),
    $95c35ea47ac23405$var$load("4we3T"),
    $95c35ea47ac23405$var$load("gavZG"),
    $95c35ea47ac23405$var$load("1hjmQ"),
    $95c35ea47ac23405$var$load("h4Nf7"),
    $95c35ea47ac23405$var$load("4fCJZ"),
    $95c35ea47ac23405$var$load("dTsOE"),
    $95c35ea47ac23405$var$load("9FBaW"),
    $95c35ea47ac23405$var$load("2S1L6"),
    $95c35ea47ac23405$var$load("6StWh"),
    $95c35ea47ac23405$var$load("g9CVe"),
    $95c35ea47ac23405$var$load("U7y88"),
    $95c35ea47ac23405$var$load("fEx3B"),
    $95c35ea47ac23405$var$load("dJQEi"),
    $95c35ea47ac23405$var$load("6qah4"),
    $95c35ea47ac23405$var$load("j4gWN"),
    $95c35ea47ac23405$var$load("87F9B"),
    $95c35ea47ac23405$var$load("4aLlP"),
    $95c35ea47ac23405$var$load("aZinD"),
    $95c35ea47ac23405$var$load("c6MKV"),
    $95c35ea47ac23405$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("bAGUV", function(module, exports) {

let $870458f568e755e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $870458f568e755e1$var$load("k7roz"),
    $870458f568e755e1$var$load("is6uI"),
    $870458f568e755e1$var$load("4gZEH"),
    $870458f568e755e1$var$load("gkmZg"),
    $870458f568e755e1$var$load("kQvbt"),
    $870458f568e755e1$var$load("jQFGH"),
    $870458f568e755e1$var$load("fQ1rW"),
    $870458f568e755e1$var$load("4tUsp"),
    $870458f568e755e1$var$load("26IOy"),
    $870458f568e755e1$var$load("2nuqm"),
    $870458f568e755e1$var$load("giPb3"),
    $870458f568e755e1$var$load("ecOVI"),
    $870458f568e755e1$var$load("7X74w"),
    $870458f568e755e1$var$load("4we3T"),
    $870458f568e755e1$var$load("gavZG"),
    $870458f568e755e1$var$load("1hjmQ"),
    $870458f568e755e1$var$load("h4Nf7"),
    $870458f568e755e1$var$load("4fCJZ"),
    $870458f568e755e1$var$load("9FBaW"),
    $870458f568e755e1$var$load("2S1L6"),
    $870458f568e755e1$var$load("6StWh"),
    $870458f568e755e1$var$load("g9CVe"),
    $870458f568e755e1$var$load("U7y88"),
    $870458f568e755e1$var$load("fEx3B"),
    $870458f568e755e1$var$load("dJQEi"),
    $870458f568e755e1$var$load("6qah4"),
    $870458f568e755e1$var$load("j4gWN"),
    $870458f568e755e1$var$load("87F9B"),
    $870458f568e755e1$var$load("aZinD"),
    $870458f568e755e1$var$load("c6MKV"),
    $870458f568e755e1$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("cnJpO", function(module, exports) {

let $903adc8f6df29dd9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $903adc8f6df29dd9$var$load("k7roz"),
    $903adc8f6df29dd9$var$load("is6uI"),
    $903adc8f6df29dd9$var$load("lnKog"),
    $903adc8f6df29dd9$var$load("4gZEH"),
    $903adc8f6df29dd9$var$load("gkmZg"),
    $903adc8f6df29dd9$var$load("kQvbt"),
    $903adc8f6df29dd9$var$load("jQFGH"),
    $903adc8f6df29dd9$var$load("fQ1rW"),
    $903adc8f6df29dd9$var$load("4tUsp"),
    $903adc8f6df29dd9$var$load("26IOy"),
    $903adc8f6df29dd9$var$load("2nuqm"),
    $903adc8f6df29dd9$var$load("giPb3"),
    $903adc8f6df29dd9$var$load("ecOVI"),
    $903adc8f6df29dd9$var$load("7X74w"),
    $903adc8f6df29dd9$var$load("4we3T"),
    $903adc8f6df29dd9$var$load("gavZG"),
    $903adc8f6df29dd9$var$load("1hjmQ"),
    $903adc8f6df29dd9$var$load("h4Nf7"),
    $903adc8f6df29dd9$var$load("4fCJZ"),
    $903adc8f6df29dd9$var$load("9FBaW"),
    $903adc8f6df29dd9$var$load("2S1L6"),
    $903adc8f6df29dd9$var$load("6StWh"),
    $903adc8f6df29dd9$var$load("g9CVe"),
    $903adc8f6df29dd9$var$load("U7y88"),
    $903adc8f6df29dd9$var$load("fEx3B"),
    $903adc8f6df29dd9$var$load("dJQEi"),
    $903adc8f6df29dd9$var$load("6qah4"),
    $903adc8f6df29dd9$var$load("j4gWN"),
    $903adc8f6df29dd9$var$load("87F9B"),
    $903adc8f6df29dd9$var$load("aZinD"),
    $903adc8f6df29dd9$var$load("c6MKV"),
    $903adc8f6df29dd9$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("5Zv3R", function(module, exports) {

let $45cabe60a1a7f8c2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $45cabe60a1a7f8c2$var$load("k7roz"),
    $45cabe60a1a7f8c2$var$load("is6uI"),
    $45cabe60a1a7f8c2$var$load("lnKog"),
    $45cabe60a1a7f8c2$var$load("4gZEH"),
    $45cabe60a1a7f8c2$var$load("gkmZg"),
    $45cabe60a1a7f8c2$var$load("kQvbt"),
    $45cabe60a1a7f8c2$var$load("jQFGH"),
    $45cabe60a1a7f8c2$var$load("fQ1rW"),
    $45cabe60a1a7f8c2$var$load("4tUsp"),
    $45cabe60a1a7f8c2$var$load("26IOy"),
    $45cabe60a1a7f8c2$var$load("2nuqm"),
    $45cabe60a1a7f8c2$var$load("giPb3"),
    $45cabe60a1a7f8c2$var$load("ecOVI"),
    $45cabe60a1a7f8c2$var$load("7X74w"),
    $45cabe60a1a7f8c2$var$load("4we3T"),
    $45cabe60a1a7f8c2$var$load("gavZG"),
    $45cabe60a1a7f8c2$var$load("1hjmQ"),
    $45cabe60a1a7f8c2$var$load("h4Nf7"),
    $45cabe60a1a7f8c2$var$load("4fCJZ"),
    $45cabe60a1a7f8c2$var$load("9FBaW"),
    $45cabe60a1a7f8c2$var$load("2S1L6"),
    $45cabe60a1a7f8c2$var$load("6StWh"),
    $45cabe60a1a7f8c2$var$load("g9CVe"),
    $45cabe60a1a7f8c2$var$load("U7y88"),
    $45cabe60a1a7f8c2$var$load("fEx3B"),
    $45cabe60a1a7f8c2$var$load("dJQEi"),
    $45cabe60a1a7f8c2$var$load("6qah4"),
    $45cabe60a1a7f8c2$var$load("j4gWN"),
    $45cabe60a1a7f8c2$var$load("87F9B"),
    $45cabe60a1a7f8c2$var$load("aZinD"),
    $45cabe60a1a7f8c2$var$load("c6MKV"),
    $45cabe60a1a7f8c2$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});


parcelRegister("8a9Dm", function(module, exports) {

$parcel$export(module.exports, "getAppId", () => $2cc1b73219e08564$export$fb2283f4a44fb53);
$parcel$export(module.exports, "getModuleKey", () => $2cc1b73219e08564$export$b17b21a48c0a3273);
$parcel$export(module.exports, "getCustomContentType", () => $2cc1b73219e08564$export$9eb690901638fb96);
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
const $2cc1b73219e08564$export$d3ac53161a36a310 = (forgeData)=>{
    const extensionContext = forgeData?.extensionContexts?.[0];
    if (!extensionContext) return [];
    if (extensionContext.hasOwnProperty('extensions')) return extensionContext.extensions;
    if (extensionContext.hasOwnProperty('extensionsByType')) return extensionContext.extensionsByType;
    return [];
};

});

parcelRegister("hIaUw", function(module, exports) {

$parcel$export(module.exports, "getContentType", () => $5ff3d548ffdc5eda$export$1ef77878e4e0b972);
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};

});

parcelRegister("dizL5", function(module, exports) {

$parcel$export(module.exports, "lazyForgeUIExtensionsWithLoader", () => $55b20ed34f146485$export$350b371bfb7f5e95);
$parcel$export(module.exports, "LazyForgeUIExtensions", () => $55b20ed34f146485$export$4cbc6d03d50a8849);

var $jmjWc = parcelRequire("jmjWc");

const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("5cTwy"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);

});
parcelRegister("5cTwy", function(module, exports) {

let $3ca924add5fd78e3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ca924add5fd78e3$var$load("lnKog").then(()=>parcelRequire('2mcHd'));

});


parcelRegister("6UqI3", function(module, exports) {

$parcel$export(module.exports, "getSpaceType", () => $a3c7cd489159fe33$export$28eddf802cd184f7);
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};

});

parcelRegister("041p6", function(module, exports) {

$parcel$export(module.exports, "ForgeContentToolsItem", () => $ced39bfea5ef5993$export$9f275aff884e1431);
/* ForgeContentToolsItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $9hlns = parcelRequire("9hlns");

var $9fBoq = parcelRequire("9fBoq");

var $al4VD = parcelRequire("al4VD");
const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz131l" : "_syazn7od",
            __cmplp.className
        ])
    });
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
function $ced39bfea5ef5993$export$9f275aff884e1431({ extension: extension, onClick: onClick, isLoading: isLoading }) {
    const onClickCB = (0, $gwFzn.useCallback)((e)=>{
        e.stopPropagation();
        onClick(extension);
    }, [
        extension,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $al4VD.ContentToolsItem), {
        id: extension.id,
        isDisabled: isLoading,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, (0, $9fBoq.extensionTitle)(extension), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
            size: "small"
        }))),
        onClick: onClickCB
    });
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
};

});
parcelRegister("9fBoq", function(module, exports) {

$parcel$export(module.exports, "extensionTitle", () => $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e);

var $1c598 = parcelRequire("1c598");
const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1c598.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1c598.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};

});


parcelRegister("9MrOn", function(module, exports) {

$parcel$export(module.exports, "ContentToolsButton", () => $43c0d8bb08806c39$export$f221d384e5b0f4c3);
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $9VJDA = parcelRequire("9VJDA");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $blsJs = parcelRequire("blsJs");

var $j8UzL = parcelRequire("j8UzL");
const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $2nPZH.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isLoading: isLoading, preloadCopyItem: preloadCopyItem, preloadMoveItem: preloadMoveItem, isExternalCollaborator: isExternalCollaborator = false })=>{
    const intl = (0, $dBxQj.default)();
    const [showSpinner, setSpinner] = (0, $gwFzn.useState)(false);
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $gwFzn.useState)('auto');
    const dropdownMenuContainerRef = (0, $gwFzn.useRef)(null);
    (0, $blsJs.useSubmitSSRScriptErrors)('page-more-action-button');
    const isMoreActionButtonClickedInSSR = ()=>Boolean(window.__SSR_EVENTS_CAPTURE__?.moreActionButton && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        (window.__SSR_RENDERED__ || undefined));
    const handleOnOpenChange = (obj)=>{
        if (window.__SSR_RENDERED__ && isLoading) {
            if (!window.__SSR_EVENTS_CAPTURE__) window.__SSR_EVENTS_CAPTURE__ = {};
            window.__SSR_EVENTS_CAPTURE__.moreActionButton = true;
            setSpinner(true);
        }
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        const handleButton = async ()=>{
            if (isMoreActionButtonClickedInSSR()) {
                if (!isLoading) {
                    await preloadCopyItem?.();
                    await preloadMoveItem?.();
                    handleOnOpenChange({
                        isOpen: true
                    });
                    setSpinner(false);
                    delete window.__SSR_EVENTS_CAPTURE__?.moreActionButton;
                } else //if clicked in SSR, gotta show spinner even when SPA takes over while loading
                setSpinner(true);
            }
        };
        handleButton(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoading
    ]);
    if (isMoreActionButtonClickedInSSR() && showSpinner) {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        const SSR_ACTION_LOADING_SPINNER_STYLE = {
            marginLeft: '10px'
        };
        return /*#__PURE__*/ $gwFzn.createElement((0, $j8UzL.SSRActionLoadingSpinner), {
            spinnerId: "more-action-loading-spinner",
            actionType: "moreActionButton",
            showSpinner: true // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            styleOverride: SSR_ACTION_LOADING_SPINNER_STYLE
        });
    }
    return /*#__PURE__*/ $gwFzn.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $35pXk.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $gwFzn.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $gwFzn.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $gwFzn.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadCopyItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    preloadMoveItem: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $gwFzn.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);

});
parcelRegister("blsJs", function(module, exports) {

$parcel$export(module.exports, "useSubmitSSRScriptErrors", () => $7bdb5572ed9c8600$export$290a00987d4ffd42);

var $gwFzn = parcelRequire("gwFzn");

var $5ZqQS = parcelRequire("5ZqQS");
const $7bdb5572ed9c8600$export$290a00987d4ffd42 = (scope)=>{
    (0, $gwFzn.useEffect)(()=>{
        if (!window.__SSR_CLIENT_ERRORS__ || !window.__SSR_CLIENT_ERRORS__[scope]) return;
        const ssrErrors = window.__SSR_CLIENT_ERRORS__[scope];
        ssrErrors.forEach((error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: 'backbone'
            }));
        delete window.__SSR_CLIENT_ERRORS__[scope];
    }, [
        scope
    ]);
};

});



parcelRegister("c4sKh", function(module, exports) {

$parcel$export(module.exports, "default", () => $3633338e39044437$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $5dK2X = parcelRequire("5dK2X");

var $exYql = parcelRequire("exYql");
const $3633338e39044437$var$boxStyles = {
    root: "_2rkopd34 _18zr12x7 _1e0c116y _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i",
    default: "_bfhkm7j4",
    important: "_bfhkybec",
    primary: "_bfhkb29m",
    primaryInverted: "_bfhkvuon",
    removed: "_bfhk1gly"
};
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $3633338e39044437$var$neutral300 = '#DDDEE1';
const $3633338e39044437$var$red300 = '#FD9891';
const $3633338e39044437$var$blue300 = '#8FB8F6';
const $3633338e39044437$var$neutral1000 = '#292A2E';
const $3633338e39044437$var$styles = {
    root: "_2rkogqwt _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhkmv6i _syaz1fxt",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1e6v",
    removed: "_bfhk1gly _syaz1fxt"
};
const $3633338e39044437$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    // Use this flag for allowing negative values(numbers) in badge component when custom number field is used
    if ((0, $dh538.fg)('platform_ken_2029_negative_numbers_badge')) return typeof children === 'number' && typeof max === 'number' ? (0, $exYql.formatValueWithNegativeSupport)(children, max) : children;
    return typeof children === 'number' && max ? (0, $exYql.formatValue)(children, max) : children;
}; /**
    * __Badge__
    *
    * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
    *
    * - [Examples](https://atlassian.design/components/badge/examples)
    * - [Code](https://atlassian.design/components/badge/code)
    * - [Usage](https://atlassian.design/components/badge/usage)
    */ 
const $3633338e39044437$var$Badge = /*#__PURE__*/ (0, $gwFzn.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $dh538.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$styles.root,
            $3633338e39044437$var$styles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        "data-testid": testId,
        style: {
            backgroundColor: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $35pXk.default)([
            $3633338e39044437$var$boxStyles.root,
            $3633338e39044437$var$boxStyles[appearance]
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $3633338e39044437$var$textColors[appearance],
            children: $3633338e39044437$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
$3633338e39044437$var$Badge.displayName = 'Badge';
var $3633338e39044437$export$2e2bcd8739ae039 = $3633338e39044437$var$Badge;
const $3633338e39044437$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("exYql", function(module, exports) {

$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $1687c74e524fbc98$export$4b844743568d5983);
$parcel$export(module.exports, "formatValue", () => $1687c74e524fbc98$export$7c4d25c0c3217d8c);
function $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $1687c74e524fbc98$export$4b844743568d5983(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}
function $1687c74e524fbc98$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $1687c74e524fbc98$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $1687c74e524fbc98$var$getSafeValue(value);
    const safeMax = $1687c74e524fbc98$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});



//# sourceMappingURL=ForgeContentTools.90d7b314.js.map
